import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Core2Config,
} from "../../../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CreateJobsFromShipmentService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "delivery-shipment-hdr/backoffice-ep";
    this.httpClient = http;
  }

  createJobsFromShipment(
    shipmentToJobLine: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path+"/create-jobs-from-shipment";
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      shipmentToJobLine,
      this.getHttpHeader(visa)
    );
  }
  
  createJobsFromShipmentWithOpt(
    dto: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/create-jobs-from-shipment-with-optimization";
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }
}
